// Copyright (c) 2019 Deere & Company

import { Component } from 'react';
import OktaStateStruct from '../state/okta-state';
import PropTypes from 'prop-types';
import { withOktaAuth } from '@okta/okta-react';
import { setAgGridLicense } from '../../app/shared/services/common-functions';

class OktaState extends Component {

    async componentDidMount () {

        await this.checkAuthentication();

    }

    async componentDidUpdate ( prevProps ) {

        if ( prevProps.authState.isAuthenticated !== this.props.authState.isAuthenticated ||
            prevProps.authState.accessToken !== this.props.authState.accessToken ||
            this.props.authState.accessToken !== this.props.oktaState.accessToken ) {

            await this.checkAuthentication();
            await this.setUsername();
            await this.setUserAccessToken();

        }

    }

    async setUsername () {

        const {
            authService, authState, oktaState, actions
        } = this.props;

        if ( authState.isAuthenticated && oktaState.isAuthenticated
            && !oktaState.userFirstName ) {

            const userInfo = await authService.getUser();

            if ( userInfo && userInfo.firstName
                && userInfo.firstName !== oktaState.userFirstName ) {

                actions.updateOktaUserFirstName( userInfo.firstName );

            }

            if ( !userInfo ) {

                await this.props.authService.handleAuthentication();
                setTimeout( () => {

                    this.setUsername().then( () => {

                    } );

                }, 1000 );

            }

        }

    }

    async setUserAccessToken () {

        const { oktaState, authState } = this.props;
        const { accessToken, isAuthenticated } = authState;

        if ( isAuthenticated && accessToken && oktaState.accessToken !== accessToken ) {

            this.props.actions.updateOktaAccessToken( accessToken );

            // Set AG Grid license after access token is available
            setAgGridLicense();

            // eslint-disable-next-line no-underscore-dangle
            const tok = await this.props.authService._oktaAuth.token.decode( accessToken );
            if ( !this.props.oktaState.userFirstName &&
                tok && tok.payload && tok.payload.firstName ) {

                this.props.actions.updateOktaUserFirstName( tok.payload.firstName );

            }
            const exp = new Date( tok.payload.exp * 1000 );
            const cur = new Date();

            let renewTime = ( exp - cur );

            if ( renewTime < 0 ) renewTime = 0;

            setTimeout( () => {

                this.props.authService.updateAuthState();

            }, ( renewTime ) );

        } else if ( isAuthenticated && !accessToken ) {

            this.props.authService.login();

        }

    }

    async checkAuthentication () {

        const { isAuthenticated } = this.props.authState;

        if ( isAuthenticated ) {

            this.props.actions.updateOktaIsAuthenticated( isAuthenticated );

            await this.setUsername();

            await this.setUserAccessToken();

        }

    }

    async updateAuthentication () {

        await this.checkAuthentication();
        await this.setUsername();
        await this.setUserAccessToken();

    }

    render () {

        return ( null );

    }

}

OktaState.propTypes = {
    actions: PropTypes.object.isRequired,
    authService: PropTypes.object.isRequired,
    authState: PropTypes.object.isRequired,
    oktaState: PropTypes.instanceOf( OktaStateStruct ).isRequired
};

export default withOktaAuth( OktaState );
